const getComponentPadding = (element) => {
    const styles = window.getComputedStyle(element);
    const computedPadding = (parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight));
    return computedPadding || 0;
};
export default getComponentPadding;
